import { render, staticRenderFns } from "./PokemonCard.vue?vue&type=template&id=542e6134&scoped=true"
import script from "./PokemonCard.vue?vue&type=script&lang=js"
export * from "./PokemonCard.vue?vue&type=script&lang=js"
import style0 from "./PokemonCard.vue?vue&type=style&index=0&id=542e6134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542e6134",
  null
  
)

export default component.exports